(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["four-pack-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('four-pack-cards')) {
    customElements.define(
      'four-pack-cards',
      class FourPackCards extends HTMLElement {
        connectedCallback() {
          const textEl = this.querySelector('[data-fpb-text]');
          if (!textEl) return;
          this.text = JSON.parse(textEl.textContent);
          this.tabs = Array.from(this.querySelectorAll('[data-fpb-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-fpb-panel]'));
          this.cards = Array.from(this.querySelectorAll('[data-fpb-card]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.showPanel(tab.dataset.fpbTab, true));
            tab.addEventListener('keydown', (event) => this.onTabKey(event));
          });

          this.cards.forEach((card) => {
            const select = card.querySelector('[data-fpb-size]');
            // Keep the "From" price so it can come back when no size is chosen.
            card.fpbFrom = {
              price: card.querySelector('[data-fpb-price]').innerHTML,
              compare: card.querySelector('[data-fpb-compare]').innerHTML,
            };
            select.addEventListener('change', () => {
              this.renderCard(card);
              const option = select.selectedOptions[0];
              if (option && option.dataset.size) this.applySize(option.dataset.size, card);
            });
            card.querySelector('[data-fpb-add]').addEventListener('click', () => this.addToCart(card));
          });

          // Remembered size from an earlier visit (optional; storage may be blocked).
          let saved = null;
          try {
            saved = window.localStorage.getItem('fpb-size');
          } catch (e) {
            saved = null;
          }
          if (saved) this.applySize(saved, null);

          // Deep link: ?pack=<handle> opens its tab and points at the card;
          // ?tab=solid|mixed opens a tab.
          const params = new URLSearchParams(window.location.search);
          const target = params.get('pack') && this.cards.find((c) => c.dataset.handle === params.get('pack'));
          if (target) {
            const panel = target.closest('[data-fpb-panel]');
            this.showPanel(panel.dataset.fpbPanel, false);
            window.requestAnimationFrame(() => {
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
              target.classList.add('is-highlighted');
              window.setTimeout(() => target.classList.remove('is-highlighted'), 2400);
            });
          } else if (params.get('tab') && this.panels.some((p) => p.dataset.fpbPanel === params.get('tab'))) {
            this.showPanel(params.get('tab'), false);
          } else if (this.panels.length) {
            this.showPanel(this.panels[0].dataset.fpbPanel, false);
          }
        }

        showPanel(name, updateUrl) {
          if (!this.panels.some((p) => p.dataset.fpbPanel === name)) return;
          this.tabs.forEach((tab) => {
            const on = tab.dataset.fpbTab === name;
            tab.setAttribute('aria-selected', String(on));
            tab.tabIndex = on ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            panel.hidden = panel.dataset.fpbPanel !== name;
          });
          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('tab', name);
            url.searchParams.delete('pack');
            window.history.replaceState({}, '', url);
          }
        }

        onTabKey(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const index = this.tabs.indexOf(event.currentTarget);
          const next = this.tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
          this.showPanel(next.dataset.fpbTab, true);
          next.focus();
        }

        // Pick the same size on every card that has it in stock.
        applySize(size, source) {
          try {
            window.localStorage.setItem('fpb-size', size);
          } catch (e) {
            /* storage unavailable: size simply isn't remembered */
          }
          this.cards.forEach((card) => {
            if (card === source) return;
            const select = card.querySelector('[data-fpb-size]');
            const option = Array.from(select.options).find((o) => o.dataset.size === size && !o.disabled);
            select.value = option ? option.value : '';
            this.renderCard(card);
          });
        }

        renderCard(card) {
          const select = card.querySelector('[data-fpb-size]');
          const option = select.selectedOptions[0];
          const chosen = option && option.value;
          select.classList.remove('is-invalid');
          card.querySelector('[data-fpb-error]').hidden = true;
          card.querySelector('[data-fpb-from]').hidden = !!chosen;
          card.querySelector('[data-fpb-price]').innerHTML = chosen ? option.dataset.price : card.fpbFrom.price;
          card.querySelector('[data-fpb-compare]').innerHTML = chosen ? option.dataset.compare || '' : card.fpbFrom.compare;
        }

        showError(card, message) {
          const error = card.querySelector('[data-fpb-error]');
          error.textContent = message;
          error.hidden = false;
        }

        addToCart(card) {
          const select = card.querySelector('[data-fpb-size]');
          const button = card.querySelector('[data-fpb-add]');
          const label = card.querySelector('[data-fpb-add-label]');
          if (!select.value) {
            select.classList.add('is-invalid');
            this.showError(card, this.text.chooseSize);
            select.focus();
            return;
          }
          if (button.classList.contains('is-loading')) return;

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const body = new FormData();
          body.append('id', select.value);
          body.append('quantity', 1);
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.append('sections', cart.getSectionsToRender().map((s) => s.id));
            body.append('sections_url', window.location.pathname);
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
          }

          button.classList.add('is-loading');
          card.querySelector('[data-fpb-error]').hidden = true;

          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.showError(card, response.description || response.message || this.text.addError);
                return;
              }
              label.textContent = this.text.addedLabel;
              window.setTimeout(() => {
                label.textContent = this.text.buttonLabel;
              }, 2000);
              if (cart && typeof cart.renderContents === 'function' && response.sections) {
                cart.renderContents(response);
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'four-pack-cards', productVariantId: select.value });
                }
              } else {
                window.location.href = `${root}cart`;
              }
            })
            .catch(() => this.showError(card, this.text.addError))
            .finally(() => button.classList.remove('is-loading'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
